import { useSeo } from "@/hooks/useSeo";
import SeoSchema from "@/components/SeoSchema";

// Centralized, route-aware SEO manager: applies head metadata (title,
// description, keywords, canonical, OG, Twitter) and injects Schema.org
// JSON-LD for the active route.
export default function SeoManager() {
  useSeo();

  return <SeoSchema />;
}